import { render, staticRenderFns } from "./inconsistencias.vue?vue&type=template&id=a5ecde36&scoped=true&"
import script from "./inconsistencias.vue?vue&type=script&lang=js&"
export * from "./inconsistencias.vue?vue&type=script&lang=js&"
import style0 from "./inconsistencias.vue?vue&type=style&index=0&id=a5ecde36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ecde36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
